import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const WishListDetailViewStyle = styled.div`
  .wishlist-detail-view__dropdown-wrapper {
    position: relative;
  }

  .wishlist-detail-backtolanding {
    background-color: unset;
    direction: rtl;
    ::after {
      transform: rotate(180deg) !important;
    }
  }

  .wishlist-detail-view__dropdown_section {
    gap: ${toRem(16)};
  }

  .wishlist-detail-view__dropdown {
    position: absolute;
    top: calc(100% + ${toRem(8)});
    left: 0;
    z-index: 200;
    width: min(${toRem(375)}, calc(100vw - ${toRem(32)}));

    @media ${baseVariables.mediaQuery.md} {
      width: ${toRem(712)};
    }

    .date-picker-wrapper {
      .date-input-field-wrapper {
        display: none;
      }
    }
  }

  .wishlist-detail-view__dropdown--datepicker {
    .shop-datepicker-dropdown {
      margin: 0 !important;
      box-shadow: none !important;
      border: 0 !important;
    }
  }

  .wishlist-detail-view__datepicker-footer,
  .wishlist-detail-view__dropdown--rooms .m-dropdown-footer,
  .wishlist-detail-view__dropdown--rooms .m-dropdown-action-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${toRem(16)};
    padding-top: ${toRem(24)};
  }

  .wishlist-detail-view__dropdown--rooms {
    width: min(${toRem(623)}, calc(100vw - ${toRem(32)}));
    background: ${baseVariables.color.base20};
    box-shadow: 0 ${toRem(8)} ${toRem(24)} ${baseVariables.color.neutral30};
    padding: ${toRem(16)};
    border-radius: ${toRem(4)};

    @media ${baseVariables.mediaQuery.md} {
      width: ${toRem(623)};
    }

    .party-mix-input-container {
      display: none;
    }

    .dropdown-container-div,
    .dropdown-container,
    .m-dropdown-container,
    .dropdown-to-modal {
      position: static !important;
      width: 100% !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
      inset: auto !important;
      z-index: auto !important;
      padding: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
    }
    .m-dropdown-container {
      box-shadow: 0 !important;
    }

    .m-dropdown-content,
    .room-guest-dropdown {
      height: auto !important;
      max-height: none !important;
      min-height: 0 !important;
      overflow: visible !important;
      border-radius: ${toRem(8)};
      padding: ${toRem(16)} !important;
      background: ${baseVariables.color.base20};
    }

    .m-dropdown-header {
      display: none;
    }

    .m-dropdown-children {
      overflow: visible;
      padding: 0;
    }

    .m-dropdown-children > div {
      padding: 0;
    }

    .stepper-text-contianer {
      & + .stepper-text-contianer {
        margin-top: ${toRem(16)};
      }

      .m-stepper-wrapper {
        min-height: ${toRem(55)};
        padding: ${toRem(8)} 0;
      }

      &:first-child .m-stepper-wrapper {
        min-height: ${toRem(48)};
      }

      .m-stepper-label {
        padding-left: 0;
      }
    }

    .m-stepper-wrapper-square .m-stepper-square {
      min-width: ${toRem(118)};
    }

    .m-stepper-wrapper-square .m-stepper-square .counter {
      width: ${toRem(54)};
      font-size: ${toRem(22)}; //added for stepper text
      line-height: ${toRem(28)};
      border: 0;
    }

    .m-stepper-wrapper-square .m-stepper-square .decrement-btn,
    .m-stepper-wrapper-square .m-stepper-square .increment-btn {
      width: ${toRem(32)};
      height: ${toRem(32)};
      border-radius: 50%;
    }

    .m-dropdown-action-bar {
      position: static !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${toRem(188)};
      padding: ${toRem(16)} 0 0 !important;
      background: ${baseVariables.color.base20} !important;

      .apply-button {
        min-width: ${toRem(64)};
      }
    }

    .child-collection {
      display: none;
    }

    @media (max-width: ${toRem(767)}) {
      width: min(${toRem(375)}, 100vw);
      max-height: calc(100dvh - ${toRem(32)});
      padding: ${toRem(24)};
      overflow-y: auto;

      .m-dropdown-header {
        display: flex;
        padding: 0 0 ${toRem(16)};
      }

      .stepper-text-contianer {
        background: ${baseVariables.color.neutral10};
      }

      .m-dropdown-action-bar {
        gap: ${toRem(16)};
      }
    }
  }

  .wishlist-detail-view__card-wrapper {
    position: relative;
    width: 100%;
    max-width: ${toRem(364)};
    margin: 0 auto;

    .property-card {
      width: ${toRem(364)};
      min-height: ${toRem(404)};
      margin-top: 0 !important;
      background: ${baseVariables.color.base20};
    }

    .property-card__img-container,
    .property-card__img-container--img,
    .property-card__img-container--img img {
      width: 100%;
      height: ${toRem(228)};
      object-fit: cover;
    }

    .property-card__img-container {
      overflow: hidden;
      .glide__track {
        .glide__slide {
          width: 100% !important;
        }
      }
    }

    .property-card__details-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: auto !important;
    }

    .property-card__title {
      padding: 0 ${toRem(16)} !important;
    }

    .property-card__reviews-miles a,
    .property-card__reviews-miles .ratings-container {
      pointer-events: none;
      cursor: default;
    }
  }

  .property-card__details-container_footer {
    .footer-container {
      align-items: center;
    }
  }

  .property-card__tertiary-link {
    padding: 0 !important;
  }

  .wishlist-detail-view__heart-btn {
    position: absolute;
    top: ${toRem(16)};
    left: ${toRem(316)};
    z-index: 3;
    width: ${toRem(24)};
    height: ${toRem(24)};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${toRem(4)};
    border-radius: ${toRem(4)};
    background-color: rgba(28, 28, 28, 0.5);

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
    .icon {
      right: ${toRem(2)};
      bottom: ${toRem(2)};
      left: unset;
      top: unset;
    }
  }

  .wishlist-detail-view__divider {
    border-top: ${toRem(1)} solid ${baseVariables.color.neutral30};
    margin: ${toRem(16)} 0;
  }

  .wishlist-detail-view__pagination {
    display: flex;
    justify-content: center;
  }

  .wishlist-detail-view__error-message,
  .wishlist-detail-view__error-message .icon-warning {
    color: ${baseVariables.color.alert40} !important;
  }

  .find-favourite-card {
    .card {
      margin: 0 !important;
    }
    justify-content: flex-start !important;  
  }
`;
